<template>
  <div class="audit_platform">
    <div class="ap_banner">
      <div class="ap_banner_info">
        <h1>智能人机协同作业平台，快速获得内容安审能力</h1>
        <h2>
          提供标准化内容审核平台，可用于：个人&企业认证、文本、图像、视频、图文、音频内容安全审核
        </h2>
        <h2 class="Mt16">支持自定义有害标签及过滤规则，可本地化部署。</h2>
        <div class="ap_banner_ljsq" @click="showSubmitDialog">
          <p>立即咨询</p>
        </div>
      </div>
    </div>
    <div class="ap_tongdian">
      <h1>行业痛点</h1>
      <div class="ap_tongdian_content">
        <div class="ap_tongdian_item">
          <img src="@/assets/images/zhineng/tongdian1@2x.png" alt="" />
          <h2 class="Mb28">数据无法开放</h2>
          <h3>部分涉密企业要求内容只能本地化存储，较强的</h3>
          <h3>信息安全要求使部分流程无法进行分包或拆分。</h3>
        </div>
        <div class="ap_tongdian_item">
          <img src="@/assets/images/zhineng/tongdian2@2x.png" alt="" />
          <h2 class="Mb28">运营者缺少内容安全风控经验</h2>
          <h3>平台运营者往往有很强的业务能力，但缺乏业务</h3>
          <h3>流程运营视角，故在运营质量和效能提升上，需</h3>
          <h3>要更多摸索和尝试。</h3>
        </div>
        <div class="ap_tongdian_item">
          <img src="@/assets/images/zhineng/tongdian3@2x.png" alt="" />
          <h2 class="Mb28">开发维护成本较高</h2>
          <h3>流程的改进和平台的升级，都会带来大量的技术</h3>
          <h3>投入和研发成本。</h3>
        </div>
      </div>
    </div>
    <div class="ap_service">
      <h1>服务内容</h1>
      <div class="ap_service_content">
        <div class="ap_service_item">
          <img src="@/assets/images/zhineng/service1@2x.png" alt="" />
          <h2 class="Mb24">企业&个人认证审核平台</h2>
          <h3>
            支持企业&个人认证审核作业，提供字段定制、流程定制、角色定制、运营看板等功能。
          </h3>
        </div>
        <div class="ap_service_item">
          <img src="@/assets/images/zhineng/service2@2x.png" alt="" />
          <h2 class="Mb24">内容审核平台</h2>
          <h3>
            支持视频、音频、图像、文字、文章内容安审作业，提供标签定制、关键词定制、流程定制、角色定制、运营看板等功能。
          </h3>
        </div>
      </div>
    </div>
    <div class="ap_liucheng">
      <h1>服务流程</h1>
      <div class="ap_liucheng_content">
        <img src="@/assets/images/zhineng/liucheng_detail@2x.png" alt="" />
        <div class="ap_liucheng_title">
          <h2>平台需求调研</h2>
          <h2>标签及流程设计</h2>
          <h2>平台部署</h2>
          <h2>投入使用</h2>
        </div>
      </div>
    </div>
    <div class="ap_gongneng">
      <h1>产品功能</h1>
      <div class="ap_gongneng_content">
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>自定标签/规则配置</h2>
          <h3>
            根据不同的业务场景和平台差异化，定义字段和标签，且可同时满足多套标签。
          </h3>
        </div>
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>审核流程配置</h2>
          <h3>
            根据不用的业务场景和准确率要求，配置对应审核模式和流程，确保审核质量和时效。
          </h3>
        </div>
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>权限角色配置</h2>
          <h3>
            根据团队特性，灵活定义不同的角色和权限，如：审核员、质检员、主管、管理员等。
          </h3>
        </div>
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>运营看板</h2>
          <h3>
            支持个人、项目、业务等多维度的数据展示，量化运营数据，为团队精细化原因提供参考。
          </h3>
        </div>
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>多端协同</h2>
          <h3>可进行移动端与PC端协同作业，实现全时段及多场景覆盖。</h3>
        </div>
        <div class="ap_gongneng_item">
          <img src="@/assets/images/zhineng/product1@2x.png" alt="" />
          <h2>在线培训</h2>
          <h3>关联业务标准培训及能力考核，帮助团队快速掌握业务能力。</h3>
        </div>
      </div>
    </div>
    <div class="ap_footer_btn" @click="showSubmitDialog">
      <p>立即咨询</p>
    </div>
    <submitDialog ref="submitDialog"></submitDialog>
  </div>
</template>

<script>
import submitDialog from '@/components/SubmitDialog'
export default {
  metaInfo: {
    title: '智能人机协同审核平台|自定标签_灵活权限_多场景覆盖-知道创宇云安全',
  },
  components: {
    submitDialog,
  },
  methods: {
    showSubmitDialog() {
      this.$refs.submitDialog.dialogVisible = true
    },
  },

  mounted() {
    const mvp = document.getElementById('testViewport')
    mvp.setAttribute('content', 'width=1230')
  },
}
</script>

<style lang="scss">
.audit_platform {
  color: #333;
  text-align: center;
  h1 {
    font-size: 30px;
    font-weight: 400;
  }
  h2 {
    font-size: 24px;
    font-weight: 400;
  }
  h3 {
    color: #888888;
    font-size: 16px;
    line-height: 2;
    font-weight: 400;
    text-align: left;
  }
  .ap_banner {
    background-image: url('../../../assets/images/zizhi/banner_detail@2x.png');
    background-position: center;
    background-size: cover;
    height: 380px;
    min-width: 1230px;
    text-align: left;
    .ap_banner_info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 1200px;
      height: 380px;
      margin: 0 auto;
      h1 {
        color: #ecedf4;
        font-size: 32px;
        margin-bottom: 30px;
      }
      h2 {
        color: #979bb6;
        font-size: 16px;
      }
      .ap_banner_ljsq {
        margin-top: 50px;
        cursor: pointer;
        width: 160px;
        height: 48px;
        background: url('../../../assets/images/content/ljsq_bg@2x.png')
          no-repeat;
        background-size: 160px 48px;
        &:hover {
          opacity: 0.9;
        }
        p {
          color: #fff;
          text-align: center;
          line-height: 48px;
          font-size: 18px;
        }
      }
    }
  }
  .ap_tongdian {
    background: #f6f8fb;
    padding-top: 63px;
    padding-bottom: 81px;
    min-width: 1230px;
    .ap_tongdian_content {
      display: flex;
      justify-content: center;
      margin-top: 63px;
    }
    .ap_tongdian_item {
      width: 384px;
      height: 384px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;
      margin-right: 23px;
      padding: 0 22px;
      flex: none;
      &:last-child {
        margin-right: 0;
      }
      img {
        width: 120px;
        height: 120px;
        margin-top: 56px;
        margin-bottom: 18px;
      }
    }
  }
  .ap_service {
    padding-top: 79px;
    padding-bottom: 80px;
    min-width: 1230px;
    .ap_service_content {
      display: flex;
      justify-content: center;
      margin-top: 63px;
      .ap_service_item {
        width: 440px;
        height: 336px;
        border: 1px solid rgba(229, 229, 229, 1);
        flex: none;
        box-sizing: border-box;
        margin-right: 79px;
        padding: 0 42px;
        &:last-child {
          margin-right: 0;
          padding: 0 34px;
        }
        img {
          width: 105px;
          height: 120px;
          margin-top: 28px;
          margin-bottom: 12px;
        }
      }
    }
  }
  .ap_liucheng {
    background: #f6f8fb;
    padding-top: 79px;
    padding-bottom: 81px;
    min-width: 1230px;
    img {
      margin-top: 64px;
      width: 859px;
      height: 120px;
    }
    .ap_liucheng_title {
      display: flex;
      margin: 0 auto;
      width: 828px;
      margin-top: 32px;
      h2 {
        font-size: 16px;
        &:nth-child(2) {
          margin-left: 142px;
        }
        &:nth-child(3) {
          margin-left: 156px;
        }
        &:nth-child(4) {
          margin-left: 184px;
        }
      }
    }
  }
  .ap_gongneng {
    padding-top: 80px;
    min-width: 1230px;
    .ap_gongneng_content {
      padding-top: 63px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 1200px;
      margin: 0 auto;
    }
    .ap_gongneng_item {
      width: 384px;
      height: 384px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(229, 229, 229, 1);
      box-sizing: border-box;
      flex: none;
      margin-bottom: 40px;
      padding: 0 28px;
      h2 {
        margin-bottom: 30px;
      }
      img {
        width: 120px;
        height: 120px;
        margin-top: 57px;
        margin-bottom: 16px;
      }
    }
  }
  .ap_footer_btn {
    margin-top: 40px;
    margin-bottom: 80px;
    min-width: 1230px;
    display: flex;
    justify-content: center;
    p {
      width: 160px;
      height: 48px;
      background: rgba(10, 158, 250, 1);
      border-radius: 2px;
      font-size: 18px;
      color: #fff;
      line-height: 48px;
      cursor: pointer;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
</style>
